import gql from "graphql-tag";

const TERMS_AND_CONDITIONS = gql`
  query GetTermsAndConditions {
    termsAndConditions
  }
`;

export default TERMS_AND_CONDITIONS;
